import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Collapse } from 'reactstrap';
import Spin from '../../components/loading';
import TicketMessages from './ticketMessages.jsx';
import * as ticketsActions from '../../redux/tickets/actions';
import { enumHelper, domManipulator } from '../../utils';
import ENUMS from '../../enums';
import { NavLink } from 'react-router-dom';
import AlertAndConfirmation from '../../utils/AlertAndConfirmation';

class TicketDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      content: '',
      contentInputValidateStatus: '',
      contentInputInvalidMessage: '',
      error: {}
    };
  }

  componentDidMount() {
    if (this.props.location.ticketId) {
      this.props.fetchTicketById(this.props.location.ticketId);
    } else {
      this.props.history.push('/tickets');
    }
  }

  validateForm = () => {
    return new Promise(resolve => {
      let { content } = this.state;

      let isContentValid;
      let firstErrorElementId = '';
      let errors = {};

      if (!content) {
        errors.contentInputInvalidMessage = locales('messages.fieldValueIsRequired', {
          fieldName: locales('tables.reply')
        });
        errors.contentInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'content';
        isContentValid = false;
      } else {
        errors.contentInputInvalidMessage = '';
        errors.contentInputValidateStatus = '';
        isContentValid = true;
      }

      if (!isContentValid) {
        this.setState(
          () => ({
            ...errors
          }),
          () => {
            domManipulator.scrollIntoView(firstErrorElementId);
            resolve(false);
          }
        );
      } else {
        resolve(true);
      }
    });
  };

  closeTicket = () => {
    let { closeTicketFailed, closeTicketMessage, closeTicketError } = this.props;

    this.props.closeTicket(this.props.location.ticketId).then(_ => {
      if (closeTicketFailed == false && closeTicketError == false && closeTicketMessage == null) {
        this.props.history.push('/tickets');
      } else {
        domManipulator.scrollToTop();
      }
    });
  };

  sendReply = async event => {
    event.preventDefault();

    let { content } = this.state;
    let { replyToTicketFailed, replyToTicketMessage, replyToTicketError } = this.props;

    const isFormValid = await this.validateForm();
    if (!isFormValid) {
      return;
    }

    this.props.replyToTicket(this.props.location.ticketId, content).then(_ => {
      if (replyToTicketFailed == false && replyToTicketMessage == null && replyToTicketError == false) {
        AlertAndConfirmation({
          title: locales('titles.insertedSuccessfully'),
          text: '',
          type: 'success'
        });
        this.props.fetchTicketById(this.props.location.ticketId);
        this.setState({content:""})
      } else {
        domManipulator.scrollToTop();
      }
    });
  };

  handleContentChange = event => this.setState({ content: event.target.value });

  render() {
    let { isOpen, content, contentInputInvalidMessage, contentInputValidateStatus } = this.state;

    let {
      ticketByIdLoading,
      ticketByIdError,
      ticketByIdFailed,
      ticketByIdMessage,
      ticketById,

      replyToTicketLoading,
      replyToTicketError,
      replyToTicketFailed,
      replyToTicketMessage,

      closeTicketLoading,
      closeTicketError,
      closeTicketFailed,
      closeTicketMessage,

      meInfo
    } = this.props;

    let { title, lastUpdatedAt, status, createdFullName, createdBy, createdAt, messages = [] } = ticketById;

    let { firstName, lastName, selectedRole } = meInfo;

    return (
      <>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-3">
            <div className="text-right">{locales('titles.ticketDetails')}</div>
          </h3>
          <div>
            <button onClick={this.closeTicket} className="btn btn-success w-5 mx-1">
              <i className="fa fa-save" />
              {locales('labels.closeTicket')}
            </button>
            <button onClick={() => this.props.history.push('/tickets')} className="btn btn-default w-5 mx-1">
              <i className="fa fa-reply" />
              {locales('labels.cancel')}
            </button>
          </div>
        </div>
        <section className="p-1 col-12">
          <Spin spinning={ticketByIdLoading || replyToTicketLoading || closeTicketLoading}>
            <article>
              <main className="panel panel-default">
                {(ticketByIdError || replyToTicketError || closeTicketError) && (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                )}
                {(ticketByIdFailed || replyToTicketFailed || closeTicketFailed) && (
                  <div className="alert alert-danger">
                    {ticketByIdMessage || replyToTicketMessage || closeTicketMessage}
                  </div>
                )}

                <div className="panel-heading">
                  <i className="fas fa-list-alt px-1" />
                  {locales('titles.ticketInformation')}
                </div>
                <div className="panel-body">
                  <div className="form-row py-3 px-2">
                    <div className="d-flex flex-wrap">
                      <span>{locales('tables.title')} : </span>
                      <span className="text-dark font-weight-bold font-large">{title}</span>
                    </div>
                  </div>

                  <div className="form-row py-3 px-2">
                    <div className="d-flex flex-wrap">
                      <span className="">{locales('tables.status')} : </span>
                      <span className="text-dark font-weight-bold font-large">
                        {enumHelper.convertEnumValueToTitle(ENUMS.TICKETS_STATUS.list, status)}
                      </span>
                    </div>
                  </div>

                  <div className="form-row py-3 px-2">
                    <div className="d-flex flex-wrap">
                      <span>{locales('titles.sentAt')} : </span>
                      <span className="text-dark font-weight-bold font-large">{createdAt}</span>
                    </div>
                  </div>

                  <div className="form-row py-3 px-2">
                    <div className="d-flex flex-wrap">
                      <span>{locales('tables.lastUpdate')} : </span>
                      <span className="text-dark font-weight-bold font-large">{lastUpdatedAt}</span>
                    </div>
                  </div>

                  <div className="form-row py-3 px-2">
                    <div className="d-flex flex-wrap">
                      <span>{locales('tables.creator')} : </span>
                      <NavLink
                        to={{
                          pathname: '/users/edit',
                          userId: createdBy,
                          editMode: true
                        }}
                      >
                        {createdFullName}
                      </NavLink>
                    </div>
                  </div>
                </div>
              </main>
            </article>

            <article className="py-3">
              <main className="panel panel-default">
                <div
                  onClick={() => this.setState({ isOpen: !this.state.isOpen })}
                  className="panel-heading d-flex justify-content-between align-items-center pointer"
                >
                  <div>
                    <i className="fas fa-pencil-alt px-1" />
                    {locales('titles.response')}
                  </div>
                  <div>
                    <i className="fas fa-plus-circle" />
                  </div>
                </div>

                <Collapse isOpen={isOpen} className="p-4">
                  <div className="d-flex col-6 justify-content-between">
                    <div className="form-row">
                      <div className="d-flex flex-wrap">
                        <span>{locales('titles.FullName')} : </span>
                        <span className="text-dark font-weight-bold font-large">
                          {' '}
                          {` ${firstName} ${lastName}`}
                        </span>
                      </div>
                    </div>

                    <div className="form-row">
                      <div className="d-flex flex-wrap">
                        <span>{locales('tables.role')} : </span>
                        <span className="text-dark font-weight-bold font-large"> {selectedRole.title}</span>
                      </div>
                    </div>
                  </div>

                  <div className="form-group  d-flex required align-items-center">
                    <label className="rsee-form-label" htmlFor="content">
                      {locales('tables.message')}
                    </label>
                    <div className="col my-3">
                      <textarea
                        id="content"
                        name="content"
                        className={`form-control ${contentInputValidateStatus}`}
                        onChange={this.handleContentChange}
                        autoComplete="off"
                        placeholder={`${locales('labels.writeReply')}...`}
                        value={content}
                      />
                      <div
                        className={`invalid-feedback ${
                          !!contentInputInvalidMessage ? 'is-invalid-feedback' : ''
                        }`}
                      >
                        {contentInputInvalidMessage}
                      </div>
                    </div>
                  </div>

                  <div className="d-flex w-100 justify-content-end">
                    <button onClick={this.sendReply} className="btn btn-success w-5 mx-1">
                      {locales('titles.send')}
                    </button>
                    <button
                      onClick={() => this.setState({ isOpen: false })}
                      className="btn btn-default w-5 mx-1"
                    >
                      <i className="fa fa-reply" />
                      {locales('labels.cancel')}
                    </button>
                  </div>
                </Collapse>
              </main>
            </article>

            <div className="my-4">
              <TicketMessages messages={messages} />
            </div>
          </Spin>
        </section>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    ticketById: state.ticketsReducer.ticketById,
    ticketByIdLoading: state.ticketsReducer.ticketByIdLoading,
    ticketByIdMessage: state.ticketsReducer.ticketByIdMessage,
    ticketByIdError: state.ticketsReducer.ticketByIdError,
    ticketByIdFailed: state.ticketsReducer.ticketByIdFailed,

    replyToTicketLoading: state.ticketsReducer.replyToTicketLoading,
    replyToTicketMessage: state.ticketsReducer.replyToTicketMessage,
    replyToTicketError: state.ticketsReducer.replyToTicketError,
    replyToTicketFailed: state.ticketsReducer.replyToTicketFailed,

    closeTicketLoading: state.ticketsReducer.closeTicketLoading,
    closeTicketMessage: state.ticketsReducer.closeTicketMessage,
    closeTicketError: state.ticketsReducer.closeTicketError,
    closeTicketFailed: state.ticketsReducer.closeTicketFailed,

    meInfo: state.authReducer.meInfo
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchTicketById: id => dispatch(ticketsActions.fetchTicketById(id)),
    replyToTicket: (id, content) => dispatch(ticketsActions.replyToTicket(id, content)),
    closeTicket: id => dispatch(ticketsActions.closeTicket(id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TicketDetails);
